import { controller } from "./controller";

// Payment
export const paymentMethods = [
  { value: "method 1", label: "method 1" },
  { value: "method 2", label: "method 2" },
  { value: "method 3", label: "method 3" },
  { value: "method 4", label: "method 4" },
];

// Patient History
export const patientHistoryprocedures = [
  { value: "123456789", label: "123456789" },
  { value: "23456789", label: "23456789" },
  { value: "3456789", label: "3456789" },
  { value: "456789", label: "456789" },
];

// Insurance FIlter
export const procedures = [
  { value: "Canada Life", label: "Canada Life" },
  { value: "Claimsecure", label: "Blue Cross" },
  { value: "Accerta", label: "Accerta" },
  { value: "Claimsecure", label: "Claimsecure" },
  { value: "sunlife", label: "Sun Life" },
  { value: "green shield", label: "Green Shield" },
  { value: "ssq", label: "SSQ" },
  { value: "rbc", label: "RBC" },
];

// Insurance FIlter
export const coverageTypes = [
  { value: "Basic", label: "Basic" },
  { value: "Major", label: "Major" },
  { value: "Orthodontics", label: "Orthodontics" },
];



// Oral Health Filter
export const healthScoreRange = [
  { key: "0-25", value: [0, 25] },
  { key: "25-50", value: [25, 50] },
  { key: "50-75", value: [50, 75] },
  { key: "75-100", value: [75, 100] },
];

export const oralHealthOptions = [
  { value: "type 1", label: "type 1" },
  { value: "type 2", label: "type 2" },
  { value: "type 3", label: "type 3" },
  { value: "type 4", label: "type 4" },
];


let scheduleTypeOptions = [];
let eventOptions = [];
let recurringOptions = [];
let actionTypeOptions = [];

// Fetch options once and cache them
(async () => {
  try {
    const response = await controller.getActionTriggerOptions();
    console.log("action_trigger", response)
    if (response && response.json) {
      scheduleTypeOptions = response.json.trigger_type || [];
      eventOptions = response.json.trigger_event || [];
      recurringOptions = response.json.recurring_period || [];
    }
  } catch (error) {
    console.error("Error fetching options:", error);
    // Set default options on error
    scheduleTypeOptions = getDefaultOptions().trigger_type;
    eventOptions = getDefaultOptions().trigger_event;
    recurringOptions = getDefaultOptions().recurring_period;
  }
})();

// Default fallback options
function getDefaultOptions() {
  return {
    trigger_type: [
      { label: "Trigger by Event", value: "event" },
      { label: "Manual Trigger", value: "manual trigger" },
      { label: "Recurring", value: "recurring" },
      { label: "Trigger by Action Completion", value: "action completion" },
    ],
    trigger_event:  [
      { "value": "appointment", "label": "Appointment" },
      { "value": "birthday", "label": "Birthday" },
      { "value": "last_login", "label": "Last Login" },
      { "value": "last_visit", "label": "Last Visit" }
    ],
    recurring_period: [
      { label: "Every Day", value: "daily" },
      { label: "Every 3 days", value: "every_3_days" },
      { label: "Every week", value: "weekly" },
      { label: "Every month", value: "monthly" },
      { label: "Every 2 months", value: "every_2_months" },
      { label: "Every 3 months", value: "every_3_months" },
      { label: "Annual", value: "annual" },
    ],
    action_type: [
      { label: "Email", value: "email" },
      { label: "SMS", value: "sms" },
      { label: "Agnet Insurance Check", value: "log_patient_payment_action" },
      { label: "Agent Treatment Check", value: "log_patient_estimate_action" },
      { label: "Agent Payment Check", value: "log_patient_breakdown_action" },
      { label: "Agent Eligibility Check", value: "log_patient_eligibility_action" },
    ]
  };
}

// Fetch options once and cache them
(async () => {
  try {
    const response = await controller.getActionTypes();
    console.log("action_types", response)
    if (response && response.json) {
      actionTypeOptions = response.json || [];
    }
  } catch (error) {
    console.error("Error fetching options:", error);
    // Set default options on error
    actionTypeOptions = getDefaultOptions().trigger_type;
  }
})();

// Export options (initially empty arrays, will be populated after fetch)
export { scheduleTypeOptions, eventOptions, recurringOptions, actionTypeOptions };


export const numberOfRetriesOptions = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
];

export const treatmentTableData = [
  {
    treatment_name: "Invisalign",
    tooth_quad: "Upper & Lower Arches",
    insurance_estimte: "850.00",
  },
  {
    treatment_name: "Implant",
    tooth_quad: "Tooth 15",
    insurance_estimte: "700.00",
  },
  {
    treatment_name: "Veneers",
    tooth_quad: "6 upper Front Teeth",
    insurance_estimte: "1000.00",
  },
];

export const activityTimelineData = [
  {
    activity: "Call Attempt",
    time: "",
    date: "",
    status: "pending",
  },
  {
    activity: "Email Sent",
    time: "",
    date: "",
    status: "processing",
  },
  {
    activity: "Appointment Book",
    time: "12:00",
    date: "2025/02/02",
    status: "done",
  },
];

export const testEmailTemplates = [
  {
    id: "1",
    title: "Email Template 1",
    subject: "Hurry Up! 30% OFF lorem ipsum lorem ipsum",
    text: "lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem ",
  },
  {
    id: "2",
    title: "Email Template 2",
    subject: "Hurry Up! 30% OFF lorem ipsum lorem ipsum",
    text: "lorem lorem lorem lorem  lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem ",
  },
  {
    id: "3",
    title: "Email Template 3",
    subject: "Hurry Up! 30% OFF lorem ipsum lorem ipsum",
    text: "lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem ",
  },
  {
    id: "4",
    title: "Email Template 4",
    subject: "Hurry Up! 30% OFF lorem ipsum lorem ipsum",
    text: "lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem ",
  },
  {
    id: "5",
    title: "Email Template 5",
    subject: "Hurry Up! 30% OFF lorem ipsum lorem ipsum",
    text: "lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem  lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem ",
  },
];
